import styled from 'styled-components';
import AvailabilityIcon from '../AvailabilityIcon/AvailabilityIcon';
var StyledAvailabilityIcon = styled(AvailabilityIcon).withConfig({
  displayName: "ProductAvailabilitystyles__StyledAvailabilityIcon",
  componentId: "vxyv8o-0"
})([""]);
var ProductList = styled.ul.withConfig({
  displayName: "ProductAvailabilitystyles__ProductList",
  componentId: "vxyv8o-1"
})(["display:flex;flex-direction:row;flex-wrap:wrap;align-items:stretch;"]);
var ProductBlockListItem = styled.li.withConfig({
  displayName: "ProductAvailabilitystyles__ProductBlockListItem",
  componentId: "vxyv8o-2"
})(["display:flex;align-items:center;position:relative;border-radius:3px;margin-bottom:15px;border:1px solid ", ";background:", ";"], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.background === 'available' ? props.theme.color.semantic.success.lighter : props.theme.color.semantic.error.lighter;
});
var ProductBlockListItemImg = styled.img.withConfig({
  displayName: "ProductAvailabilitystyles__ProductBlockListItemImg",
  componentId: "vxyv8o-3"
})(["max-width:60px;max-height:60px;padding:7px;background:", ";"], function (props) {
  return props.theme.color.monochrome.white;
});
var ProductBlockListItemDiv = styled.div.withConfig({
  displayName: "ProductAvailabilitystyles__ProductBlockListItemDiv",
  componentId: "vxyv8o-4"
})(["border:0;display:flex;align-items:center;line-height:normal;small{line-height:normal;font-weight:", ";padding:5px 5px 5px 0;}svg{margin:0 10px;min-width:25px;min-height:25px;}"], function (props) {
  return props.theme.font.weight.bold;
});
var ProductRowListPanelDiv = styled.div.withConfig({
  displayName: "ProductAvailabilitystyles__ProductRowListPanelDiv",
  componentId: "vxyv8o-5"
})(["display:block;position:relative;border-radius:2px;border:1px solid grey;margin-top:20px;width:100%;background:", ";"], function (props) {
  return props.background === 'available' ? props.theme.color.semantic.success.lighter : props.theme.color.semantic.error.lighter;
});
var ProductRowListMessageDiv = styled.div.withConfig({
  displayName: "ProductAvailabilitystyles__ProductRowListMessageDiv",
  componentId: "vxyv8o-6"
})(["border-bottom:1px solid grey;position:relative;display:flex;align-items:center;width:100%;padding:10px;svg{width:25px;height:25px;margin-right:10px;}p{margin:0;line-height:normal;}"]);
var ProductRowListContent = styled.div.withConfig({
  displayName: "ProductAvailabilitystyles__ProductRowListContent",
  componentId: "vxyv8o-7"
})(["background:", ";padding:10px;display:flex;width:100%;"], function (props) {
  return props.theme.color.monochrome.white;
});
var ProductRowListImgWrapper = styled.div.withConfig({
  displayName: "ProductAvailabilitystyles__ProductRowListImgWrapper",
  componentId: "vxyv8o-8"
})(["position:relative;padding:0 5px;"]);
export { StyledAvailabilityIcon, ProductList, ProductBlockListItem, ProductBlockListItemImg, ProductBlockListItemDiv, ProductRowListPanelDiv, ProductRowListMessageDiv, ProductRowListContent, ProductRowListImgWrapper };